// AI-generated meeting minutes: summary, topics, decisions and a task table.
import type { Minutes } from '../../../shared/types';
import { formatDateTime } from '../lib/format';
import { Icon } from './Icon';

interface MinutesCardProps {
  minutes: Minutes;
  onRegenerate?: () => void;
  busy?: boolean;
  /** The transcript changed after the minutes were written. */
  outdated?: boolean;
}

export function MinutesCard({ minutes, onRegenerate, busy, outdated }: MinutesCardProps) {
  return (
    <section className="card minutes" aria-labelledby="minutes-title">
      <div className="card__head">
        <h2 id="minutes-title" className="card__title">
          <Icon name="sparkles" size={20} /> Zapisnik sestanka
        </h2>
        {onRegenerate && (
          <button type="button" className="btn btn--ghost btn--small" onClick={onRegenerate} disabled={busy}>
            <Icon name={busy ? 'spinner' : 'refresh'} size={18} /> {busy ? 'Pripravljam …' : 'Pripravi znova'}
          </button>
        )}
      </div>
      <p className="muted small">Pripravljeno {formatDateTime(minutes.generatedAt)} · samodejni povzetek, preverite ga pred pošiljanjem.</p>
      {outdated && (
        <div className="notice notice--warning" role="status">
          <Icon name="alert" size={20} className="notice__icon" />
          <p className="notice__content">
            {`Prepis je bil po pripravi zapisnika spremenjen, zato zapisnik morda ni več točen.${
              onRegenerate ? ' Za posodobljen zapisnik izberite »Pripravi znova«.' : ''
            }`}
          </p>
        </div>
      )}

      <h3 className="minutes__h">Povzetek</h3>
      <p className="minutes__summary">{minutes.povzetek || '—'}</p>

      {minutes.teme.length > 0 && (
        <>
          <h3 className="minutes__h">Teme</h3>
          <ul className="minutes__list">
            {minutes.teme.map((t, i) => (
              <li key={i}>{t}</li>
            ))}
          </ul>
        </>
      )}

      {minutes.sklepi.length > 0 && (
        <>
          <h3 className="minutes__h">Sklepi</h3>
          <ol className="minutes__list">
            {minutes.sklepi.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ol>
        </>
      )}

      {minutes.naloge.length > 0 && (
        <>
          <h3 className="minutes__h">Naloge</h3>
          <div className="table-wrap">
            <table className="tasks">
              <thead>
                <tr>
                  <th scope="col">Naloga</th>
                  <th scope="col">Nosilec</th>
                  <th scope="col">Rok</th>
                </tr>
              </thead>
              <tbody>
                {minutes.naloge.map((n, i) => (
                  <tr key={i}>
                    <td data-label="Naloga">{n.opis}</td>
                    <td data-label="Nosilec">{n.nosilec || '—'}</td>
                    <td data-label="Rok">{n.rok || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}
